import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';
import { showSoftDeleteConflict } from 'store/slices/softDeleteSlice';

const service = axios.create({
	baseURL: API_BASE_URL,
	timeout: 60000,
});

// Config
const TOKEN_PAYLOAD_KEY = 'authorization';

const KNOWN_ERRORS = [['token.invalid', 'Token inválido']];

const getKnownError = error => {
	const knownError = KNOWN_ERRORS.find(
		knownError => knownError[0] === error.response.data.error.message
	);

	if (knownError) {
		return knownError[1];
	}

	return error.response.data.error.message;
};

// API Request interceptor
service.interceptors.request.use(
	config => {
		const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

		if (jwtToken) {
			config.headers[TOKEN_PAYLOAD_KEY] = 'Bearer ' + jwtToken;
		}

		return config;
	},
	error => {
		// Do something with request error here
		notification.error({
			message: 'Error',
		});
		Promise.reject(error);
	}
);

// API response interceptor
service.interceptors.response.use(
	response => {
		return response.data;
	},
	error => {
		console.log('error', error);
		let notificationParam = {
			message: '',
		};

		// Soft-delete conflict handling (Strapi v4 middleware returns 409)
		let errorResponse = error.response;

		let statusCode = errorResponse.status;

		if (statusCode === 409) {
			console.log('entra');
			try {
				const original = error.config || {};
				const url = original.baseURL
					? original.url?.startsWith('http')
						? original.url
						: `${original.baseURL}${original.url}`
					: original.url;
				const method = (original.method || 'put').toUpperCase();
				const body = original.data;
				const headers = original.headers;

				// Try to extract an id from URL /:collection/:id
				let entityId = null;
				try {
					const parts = (original.url || '').split('?')[0].split('/');
					entityId = parts[parts.length - 1] || null;
					if (entityId && isNaN(Number(entityId))) entityId = null;
				} catch {}

				store.dispatch(
					showSoftDeleteConflict({
						request: { url, method, body, headers },
						entityId,
						conflict: error.response.data?.error || null,
					})
				);
			} catch (e) {
				// Fallback to notification if something goes wrong
				notification.error({ message: 'Conflicto al eliminar (409)' });
			}
			return Promise.reject(error);
		}

		if (statusCode === 400) {
			notificationParam.message = 'Error de validación';
			notificationParam.description = getKnownError(error);
		}

		if (statusCode === 401) {
			notificationParam.message = 'Falló la autenticación';
			notificationParam.description = 'Por favor inicie sesión nuevamente';
			localStorage.removeItem(AUTH_TOKEN);
			localStorage.removeItem('me');

			store.dispatch(signOutSuccess());
		}

		if (statusCode === 403) {
			notificationParam.message = 'Sin permisos para esta acción';
			notificationParam.description = 'Por favor inicie sesión nuevamente';
			localStorage.removeItem(AUTH_TOKEN);
			localStorage.removeItem('me');

			store.dispatch(signOutSuccess());
		}

		if (statusCode === 404) {
			notificationParam.message = 'No se encontró el recurso';
		}

		if (statusCode === 500) {
			notificationParam.message = 'Error interno del servidor';
		}

		if (statusCode === 508) {
			notificationParam.message = 'Tiempo de espera agotado';
		}

		notification.error(notificationParam);

		return Promise.reject(error);
	}
);

export default service;
